import React from "react";
import List from "../../components/Common/List";

/**
 * Default List item
 */
function FolderList(props) {
  const { data, children, ...rest } = props;

  return (
    <List sx={{ p: 0, ...rest.sx }} {...rest}>
      {data.map(children)}
    </List>
  );
}

export default FolderList;
